import React, { useState, useEffect } from 'react';
import {
    Typography,
    Spin,
    Alert,
    Space,
} from 'antd';
import { useAuth } from '../contexts/AuthContext';
import TagGroupService from '../service/tagGroupService';
import TagGroupManager from '../components/TagGroups/TagGroupManager';
import '../styles/NewsDetail.css';

const { Title, Text } = Typography;

const UserPreferencesPage: React.FC = () => {
    const { token } = useAuth();
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (token) {
            fetchTagGroups();
        }
    }, [token]);

    const fetchTagGroups = async () => {
        setLoading(true);
        setError(null);

        try {
            await TagGroupService.getUserTagGroups();
        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleGroupsChange = async () => {
        // Refetch tag groups when they change
        await fetchTagGroups();
    };

    if (!token) {
        return (
            <div style={{ padding: '24px', textAlign: 'center' }}>
                <Alert
                    message="Authentication Required"
                    description="Please log in to manage your preferences."
                    type="info"
                    showIcon
                />
            </div>
        );
    }

    if (loading) {
        return (
            <div style={{ padding: '24px', textAlign: 'center' }}>
                <Spin size="large" />
                <div style={{ marginTop: '16px' }}>
                    <Text>Loading your preferences...</Text>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
                <Alert
                    message="Error"
                    description={error}
                    type="error"
                    showIcon
                />
            </div>
        );
    }

    return (
        <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                {/* Page Header */}
                <div style={{
                    padding: '24px',
                    backgroundColor: 'white',
                    borderRadius: 8,
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.08)'
                }}>
                    <Title level={2} style={{ marginBottom: '8px', color: '#1890ff' }}>
                        Tag Groups & Preferences
                    </Title>
                    <Text type="secondary" style={{ fontSize: '15px' }}>
                        Organize your tags into groups and get personalized news for each group.
                    </Text>
                </div>

                {/* Tag Group Manager */}
                <div style={{
                    padding: '24px',
                    backgroundColor: 'white',
                    borderRadius: 8,
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.08)'
                }}>
                    <TagGroupManager onGroupsChange={handleGroupsChange} />
                </div>
            </Space>
        </div>
    );
};

export default UserPreferencesPage;
